import {trigger, animate, style, transition} from '@angular/animations';

export function fadeInAndOut() {
    return trigger('enterAnimation', [
      transition(':enter', [
        style({opacity: 0}),
        animate(500, style({opacity: 1}))
      ])
    ]);
  }



// WEBPACK FOOTER //
// ./src/app/utils/animations-utils.ts